/**
 * > When using the esBuild API, all `process.env.NODE_ENV` expressions
 * > are automatically defined to `"production"` if all minification
 * > options are enabled and `"development"` otherwise. This only happens
 * > if `process`, `process.env`, and `process.env.NODE_ENV` are not already
 * > defined. This substitution is necessary to avoid code crashing instantly
 * > (since `process` is a Node API, not a web API).
 * > — https://esbuild.github.io/api/#platform
 */

const NODE_ENV = process.env.NODE_ENV;
const IS_MOBILE = window.matchMedia('(any-pointer:coarse)').matches;

// Main environment variables
const ENV = Object.freeze({
  // Node environment
  NAME: NODE_ENV,
  IS_PROD: NODE_ENV === 'production',
  IS_DEV: NODE_ENV === 'development',

  // Device
  IS_MOBILE,
  IS_DESKTOP: !IS_MOBILE,

  // Supports
  SUPPORTS_VH:
    'CSS' in window &&
    'supports' in window.CSS &&
    window.CSS.supports('height: 100svh') &&
    window.CSS.supports('height: 100dvh') &&
    window.CSS.supports('height: 100lvh')
});

// Main CSS classes used within the project
const CSS_CLASS = Object.freeze({
  LOADING: 'is-loading',
  LOADED: 'is-loaded',
  READY: 'is-ready',
  FIRST_LOADED: 'is-first-loaded',
  TRANSITION: 'is-transitioning',
  FONTS_LOADED: 'fonts-loaded',
  LAZY_CONTAINER: 'c-lazy',
  LAZY_LOADED: '-lazy-loaded'
  // ...
});

// Swup Fragment Plugin rule names
const SWUP_FRAGMENT = Object.freeze({
  PUBLICATION_MODAL: 'publication-modal'
});

// Custom js events
const CUSTOM_EVENT = Object.freeze({
  VISIT_START: 'visit.start',
  MODAL_OPEN: 'modal.open',
  MODAL_CLOSE: 'modal.close',
  PUBLICATION_MODAL_CLOSE: 'publication.modal.close',
  GO_TO: 'load.goTo'
  // ...
});

// Fonts parameters
const FONT = Object.freeze({
  EAGER: [
    { family: 'Sequel Sans Medium Disp', style: 'normal' },
    { family: 'Sequel Sans Medium Body', style: 'normal' },
    { family: 'Sequel Sans Book Body', style: 'normal' },
    { family: 'Maison Mono', style: 'normal' }
  ]
});

export { ENV, CSS_CLASS, CUSTOM_EVENT, FONT, SWUP_FRAGMENT };
